import { render } from "./UnitIndex.vue?vue&type=template&id=247e2d18&scoped=true"
import script from "./UnitIndex.vue?vue&type=script&lang=js"
export * from "./UnitIndex.vue?vue&type=script&lang=js"

import "./UnitIndex.vue?vue&type=style&index=0&id=247e2d18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247e2d18"]])

export default __exports__